export default __webpack_public_path__ + "static/media/figures-1.6c21dbf5.png";